import Cookie from 'react-cookie';
import { addSession, Session } from '../services/SessionStore';
import { RootDispatch } from '../store';
import CookieNames from './enums/CookieNames';
import CookieOptions from './enums/CookieOptions';

export interface PatientState {
  group_id?: string;
  session_tokens?: Session[];
  errors?: number;
  needsAuth?: string[];
}

const errInitialState = parseInt(Cookie.load(CookieNames.AUTH_ERR_COUNT)) || 0;
const initialState: PatientState = {
  errors: errInitialState,
  needsAuth: [],
};

export const patient = {
  effects: (dispatch: RootDispatch) => ({
    setPatient(patient: PatientState) {
      if ('errors' in patient && patient.errors !== 0) {
        Cookie.save(CookieNames.AUTH_ERR_COUNT, patient.errors, CookieOptions.TEN_MINUTES);
      } else {
        Cookie.remove(CookieNames.AUTH_ERR_COUNT);
      }
      if (patient.session_tokens?.length) {
        if (!patient.group_id) return;

        const lastSession = patient.session_tokens[patient.session_tokens.length - 1];
        addSession(lastSession, patient.group_id);
      }
      dispatch.patient.update(patient);
    },
  }),
  reducers: {
    update(state: PatientState, patientData: PatientState): PatientState {
      return Object.assign({}, state, patientData);
    },
  },
  state: initialState,
};
